module.exports = __webpack_public_path__ + "static/media/toolkit.3b966505.jpg";